/* global exports */
"use strict";

import ToPs from "../../client/js/components/JsToPs.js";
import RestaurantHours from "../../client/js/components/RestaurantHours.js";
var RestaurantHoursPS = ToPs(RestaurantHours);

export var init = RestaurantHoursPS.init;
export var update = RestaurantHoursPS.update;
